import { render } from "./TwArticleListFilters.vue?vue&type=template&id=9d97e12a"
import script from "./TwArticleListFilters.vue?vue&type=script&lang=js"
export * from "./TwArticleListFilters.vue?vue&type=script&lang=js"

import "./TwArticleListFilters.vue?vue&type=style&index=0&id=9d97e12a&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__